<template>
  <div class="group">
    <div class="info">
      <span>Groups</span>
    </div>
    <div class="info">
      <btn
        name="Create Group"
        @click="create"
      />
    </div>
    <list
      :items="groups"
      :columns="columns"
      :buttons="buttons"
      @edit="edit"
      @delete="deleteGroup"
    />
    <form-dialog
      v-if="formDialog"
      :item="item"
      :header="headerTitle"
      @cancel="formDialog = false; editing = false;"
      @save="save"
    />
  </div>
</template>

<script>
  import gql from 'graphql-tag';

  const textareaValueToArray = (str) => (str ? str.split('\n').map((item) => item.trim()).filter((item) => item.length > 0) : []);
  const arrayToTextareaValue = (array) => `${array.join('\n')}${array.length > 0 ? '\n' : ''}`;

  export default {
    name: 'GroupIndex',
    components: {
      list: () => import('@/views/admin/components/list.vue'),
      'form-dialog': () => import('@/views/admin/components/form-dialog.vue'),
      btn: () => import('@/views/admin/components/btn.vue'),
    },
    props: {},
    data() {
      return {
        formDialog: false,
        buttons: [{ name: 'Edit', callback: 'edit' }, { name: 'Delete', callback: 'delete' }],
        editing: false,
        item: {
          name: { value: '' },
          domains: { value: [] },
          enforcedMfa: { value: false },
        },
        columns: [
          {
            name: 'ID',
            key: 'id',
          },
          {
            name: 'Name',
            key: 'name',
          },
          {
            name: 'Domains',
            key: 'domains',
          },
          {
            name: 'Enforced MFA',
            key: 'enforcedMfa',
          },
        ],
        groups: [],
      };
    },
    apollo: {
      groups:
        gql`query {
          groups (orderBy: { name: asc }) {
            domains
            enforcedMfa
            id
            name
          }
        }
      `,
    },
    computed: {
      headerTitle() {
        return this.editing ? 'Edit Group' : 'Create Group';
      },
    },
    methods: {
      create() {
        this.item = {
          name: { value: '' },
          domains: { type: 'textarea', label: 'Domains (with or without suffix)' },
          enforcedMfa: { value: false, type: 'checkbox', label: 'Enforced MFA' },
        };
        this.formDialog = true;
        this.editing = false;
      },
      save(item) {
        if (this.editing) {
          this.$apollo.mutate({
            mutation: gql`
              mutation($id: String!, $domains: [String!], $enforcedMfa: Boolean, $name: String!) {
                updateOneGroup(
                  data: {
                    domains: { set: $domains }
                    enforcedMfa: { set: $enforcedMfa }
                    name: { set: $name },
                  },
                  where: { id: $id }
                ) {
                  id
                  name
                }
              }
            `,
            variables: {
              domains: textareaValueToArray(item.domains.value),
              enforcedMfa: item.enforcedMfa.value,
              id: item.id.value,
              name: item.name.value,
            },
          }).then(() => {
            this.$apollo.queries.groups.refetch();
          });
        } else {
          this.$apollo.mutate({
            mutation: gql`
              mutation($name: String!, $domains: [String!], $enforcedMfa: Boolean) {
                createOneGroup(data: {
                  domains: { set: $domains }
                  enforcedMfa: $enforcedMfa
                  name: $name
                }) {
                  id
                  name
                }
              }
            `,
            variables: {
              domains: textareaValueToArray(item.domains.value),
              enforcedMfa: item.enforcedMfa.value,
              name: item.name.value,
            },
          }).then(() => {
            this.$apollo.queries.groups.refetch();
          });
        }
        this.editing = false;
        this.formDialog = false;
      },
      edit(item) {
        Object.assign(this.item, {
          id: { value: item.id, disabled: true },
          name: { value: item.name },
          domains: { value: arrayToTextareaValue(item.domains), type: 'textarea', label: 'Domains (with or without suffix)' },
          enforcedMfa: { value: item.enforcedMfa, type: 'checkbox', label: 'Enforced MFA' },
        });
        this.editing = true;
        this.formDialog = true;
      },
      deleteGroup(item) {
        if (window.confirm('Are you sure you want to delete this group?')) {
          this.$apollo.mutate({
            mutation: gql`
                mutation($id: String!) {
                  deleteOneGroup(where: { id: $id }) {
                    id
                  }
                }
              `,
            variables: {
              id: item.id,
            },
          }).then(() => {
            this.$apollo.queries.groups.refetch();
          });
        }
      },
    },
  };
</script>


<style lang="stylus" scoped>

</style>
